export default function ArrowIcon({ direction = "right", className = "" }) {
  return (
    <svg
      className={`ix-arrow-icon ix-arrow-icon--${direction}${className ? ` ${className}` : ""}`}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M7.5 4.75 12.75 10 7.5 15.25" />
    </svg>
  );
}
